module.exports = require('../dist/compat/object/omit.js').omit;
